import { ActionTree } from 'vuex';
import { RootState, ProductsState } from '@/types/state';
import { UnsavedProduct, ProductInterface, ProductWithImage, Product } from '@/types/product';
import ProductsService from '@/services/ProductsService';


const actions: ActionTree<ProductsState, RootState> = {
  loadProducts(context): Promise<void> {
    return new Promise((resolve, reject) => {
      ProductsService.fetchAllProducts().then((products) => {
        context.commit('setProducts', products);
        context.commit('setDataLoaded');
        resolve();
      }).catch(reject);
    });
  },

  addProduct(context, product: UnsavedProduct): Promise<Product> {
    return new Promise((resolve, reject) => {
      ProductsService.createProduct(product)
        .then((savedProduct: ProductInterface) => {
          context.commit('addProduct', savedProduct);
          resolve(savedProduct);
        }).catch(reject);
    });
  },

  updateProduct(context, product: ProductWithImage): Promise<Product> {
    return new Promise((resolve, reject) => {
      ProductsService.updateProduct(product)
        .then((updatedProduct: ProductInterface) => {
          context.commit('updateProduct', updatedProduct);
          resolve(updatedProduct);
        }).catch(reject);
    });
  },

  deleteProduct(context, product: ProductInterface): Promise<void> {
    return new Promise((resolve, reject) => {
      ProductsService.deleteProduct(product)
        .then((deletedProduct: ProductInterface) => {
          context.commit('deleteProduct', deletedProduct);
          resolve();
        }).catch(reject);
    });
  },
};

export default actions;
